import gql from "graphql-tag";

export const SAVE_JOB_MAP = gql`
  mutation saveJobMap($where: SaveJobMap!) {
    saveJobMap(where: $where)
  }
`;